import React, { useState, useRef, useCallback, useMemo } from 'react';
import FormulaireDynamique from './formulaire-dynamique';
import CodeValidationGate from './code-validation-gate';
import { useCodeValidationGate } from './hooks/use-code-validation-gate';
import { exampleNormalFields, minimalExampleFields, multiEtapesExampleFields, columnsExampleFields, fourSectionsExampleFields, fourSectionsHorizontalExampleFields, tenStepsExampleFields, formulaireCampDeJour, formulaireFicheSanteEnfant } from './dataTemp';
import withNavigation from '../higher-order/navigation';
import './formulaire-dynamique-main.css';

const FormulaireDynamiqueMain = (props) => {
  const formRef = useRef(null);
  const [formData, setFormData] = useState({});
  const formNameFromProps = props.formName || 'campDeJour';
  const language = props?.match?.params?.language || 'fr';
  const [exampleType, setExampleType] = useState(formNameFromProps); // 'minimal', 'complete', 'etapes', 'columns', 'fourSections', 'fourSectionsHorizontal', 'tenSteps', 'campDeJour', 'ficheSanteEnfant'

  const showSubmitButton = props.showSubmitButton !== undefined
    ? props.showSubmitButton
    : (exampleType !== 'campDeJour');

  const shouldRequireCodeValidation = props?.useCodeClient === true
    || `${ props?.useCodeClient || '' }`.toLowerCase() === 'true';
  const codeSessionStorageKey = useMemo(() => {
    const idZec = props?.match?.params?.idZec || 'default';
    return `campJour_codeClient_${ idZec }`;
  }, [props?.match?.params?.idZec]);
  const {
    codeClient,
    setCodeClient,
    isCodeValidated,
    codeValidationError,
    setCodeValidationError,
    isCheckingCode,
    handleCodeFormSubmit
  } = useCodeValidationGate({ codeSessionStorageKey });

  const handleFormChange = useCallback((newFormData) => {
    // console.log('Form data changed:', newFormData);
    setFormData(newFormData);
  }, []);

  const handleSubmit = useCallback(() => {
    if (!formRef.current) {
      // console.warn('Form ref not available');
      return;
    }

    const validation = formRef.current.validate(null, true);

    if (validation.isValid) {
      const currentFormData = formRef.current.getFormData();
      // console.log('Form is valid. Submitting:', currentFormData);
      alert('Formulaire valide! Données: ' + JSON.stringify(currentFormData, null, 2));
    } else {
      // TODO
      // console.log('Validation errors:', validation.errors);
      alert('Veuillez corriger les erreurs dans le formulaire.');
    }
  }, []);

  const handleReset = useCallback(() => {
    if (formRef.current) {
      window.location.reload();
    }
  }, []);

  const handleExampleChange = useCallback((e) => {
    setExampleType(e.target.value);
  }, []);

  const getFieldsAndValues = () => {
    switch (exampleType) {
      case 'minimal':
        return { fields: minimalExampleFields, sectionsHorizontales: false, nombreColonnesSections: 1 };
      case 'etapes':
        return { fields: multiEtapesExampleFields, sectionsHorizontales: false, nombreColonnesSections: 1 };
      case 'columns':
        return { fields: columnsExampleFields, sectionsHorizontales: false, nombreColonnesSections: 1 };
      case 'fourSections':
        return { fields: fourSectionsExampleFields, sectionsHorizontales: true, nombreColonnesSections: 2 };
      case 'fourSectionsHorizontal':
        return { fields: fourSectionsHorizontalExampleFields, sectionsHorizontales: true, nombreColonnesSections: 4 };
      case 'tenSteps':
        return { fields: tenStepsExampleFields, sectionsHorizontales: false, nombreColonnesSections: 1 };
      case 'campDeJour':
        return { fields: formulaireCampDeJour, sectionsHorizontales: false, nombreColonnesSections: 1 };
      case 'ficheSanteEnfant':
        return { fields: formulaireFicheSanteEnfant, sectionsHorizontales: false, nombreColonnesSections: 1 };
      default:
        return { fields: exampleNormalFields, sectionsHorizontales: false, nombreColonnesSections: 1 };
    }
  };

  const { fields: fieldsToUse, sectionsHorizontales, nombreColonnesSections } = getFieldsAndValues();

  return (
    <div id="formulaire-dynamique-main" className="formulaire-dynamique-main">

      {/* <div className="button-container">
        <label htmlFor="example-select" className="example-select-label">
          Sélectionner un exemple:
        </label>
        <select
          id="example-select"
          value={exampleType}
          onChange={handleExampleChange}
          className="example-select"
        >
          <option value="complete">Exemple régulier complet</option>
          <option value="minimal">Exemple minimal</option>
          <option value="etapes">Exemple multiple étapes</option>
          <option value="columns">Exemple colonnes</option>
          <option value="fourSections">Exemple 4 sections verticales & 2 horizontales</option>
          <option value="fourSectionsHorizontal">Exemple 4 sections horizontales</option>
          <option value="tenSteps">Exemple 10 étapes complet</option>
          <option value="campDeJour">Formulaire Camp de Jour (Étapes customisées)</option>
          <option value="ficheSanteEnfant">Fiche de santé de l'enfant</option>
        </select>
      </div> */}

      <div className="form-wrapper">
        {shouldRequireCodeValidation && !isCodeValidated ? (
          <CodeValidationGate
            language={language}
            handleCodeFormSubmit={handleCodeFormSubmit}
            codeClient={codeClient}
            setCodeClient={setCodeClient}
            codeValidationError={codeValidationError}
            setCodeValidationError={setCodeValidationError}
            isCheckingCode={isCheckingCode}
          />
        ) : (
          <FormulaireDynamique
            ref={formRef}
            fields={fieldsToUse}
            onChange={handleFormChange}
            sectionsHorizontales={sectionsHorizontales}
            nombreColonnesSections={nombreColonnesSections}
            match={props.match}
            codeClient={shouldRequireCodeValidation ? codeClient : ''}
          />
        )}
      </div>

      {showSubmitButton && (
        <div className="buttons-container-submit-formulaire-dynamique">
          <button
            onClick={handleSubmit}
            className="submit-button-formulaire-dynamique"
          >
            SOUMETTRE
          </button>

          {/* <button
            onClick={handleReset}
            className="reset-button"
          >
            Réinitialiser
          </button> */}
        </div>
      )}

      {/* {Object.keys(formData).length > 0 && (
        <div className="form-data-container">
          <h3>Données du formulaire (test):</h3>
          <pre className="form-data-pre">
            {JSON.stringify(formData, null, 2)}
          </pre>
        </div>
      )} */}
    </div>
  );
};

export default withNavigation(FormulaireDynamiqueMain);
